import dayjs from 'dayjs';
import type { NotificationHeaderProps } from './notificationHeader.types';
import './notificationHeader.scss';

const NotificationHeader = ({ item, title }: NotificationHeaderProps) => (
  <div className="notification__header">
    <div className="notification__header__left">{title}</div>
    <div className="time">{dayjs(item.createdAt).format('HH:mm')}</div>
  </div>
);

export default NotificationHeader;
